// ClientService
import { Injectable, signal } from '@angular/core';
import PouchDB from 'pouchdb';
import PouchDBFind from 'pouchdb-find';
import { from, map, Observable } from 'rxjs';

PouchDB.plugin(PouchDBFind);
export interface ClientDoc {
  _id: string;
  name: string;
  sectorDbName: string;
}

@Injectable({
  providedIn: 'root',
})
export default class ClientService {
  private db = new PouchDB('clients');

  public selectedClient = signal<string | undefined>(undefined);
  all(): Observable<ClientDoc[]> {
    const promise = this.db
      .find({
        selector: { type: 'client' },
        limit: undefined,
      })
      .then((res) => {
        return res.docs as unknown as ClientDoc[];
      });

    return from(promise);
  }

  get(id: string) {
    const promise = this.db
      .find({
        selector: { type: 'client', _id: id },
      })
      .then((res) => res.docs[0] as unknown as ClientDoc);

    return from(promise);
  }
}
